import { type Node, type NodeProps } from '@xyflow/react';
import { NodeType } from 'automations/data/nodeTypes';

export function didNodeSyncToServer(node: Node | NodeProps<Node<any>>) {
  // If node.id is a valid number, then it is synced to BE
  return !Number.isNaN(Number(node.id));
}

export function generateNewNodePayload({
  nodeType = NodeType.newBlock,
  data = {},
} : {
  nodeType?: NodeType;
  data?: any;
} = {}): Node {
  return {
    id: crypto.randomUUID(),
    type: nodeType,
    position: { x: 0, y: 0 },
    data,
  };
}
